export default __webpack_public_path__ + "static/media/speech.ac59e551.mp4";